<div class="dialog-content">
  <div class="dialog-header">
    <div class="dialog-header-text">Add new media asset</div>
    <div class="cross-icon" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
    </div>
  </div>

  <div class="content">
    <div class="d-grid gap-2">
      <div>Image <span class="req-star">*</span></div>
      <div class="file-upload-section">
        <!-- Hidden file input -->
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept=".jpg,.png"
          hidden
        />

        <div
          class="upload-area"
          [class.upload-area-error]="uploadError"
          [class.upload-area-success]="selectedFiles.length > 0"
          (click)="triggerFileInput()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <img class="upload-icon" src="assets/images/image-add.svg" />
          <p class="upload-text">Drag & drop Image or <span>browse</span></p>
          <p class="format-info">Supported formats: PNG, JPG (Max 10MB each)</p>

          <!-- Error message -->
          <div *ngIf="uploadError" class="error-message">
            {{ uploadError }}
          </div>
        </div>

        <!-- Image preview section -->
        <div *ngIf="imagePreviews.length > 0" class="uploaded-images-container">
          <div class="uploaded-images-header">
            Selected Image
          </div>
          <div class="uploaded-images-grid">
            <div
              *ngFor="let preview of imagePreviews; let i = index"
              class="uploaded-image-item"
            >
              <img
                [src]="preview.url"
                class="image-preview"
                [alt]="preview.name"
                (error)="preview.url = 'assets/images/fallback-image.svg'"
              />
              <div class="image-actions">
                <span class="image-name" [title]="preview.name">{{
                  preview.name
                }}</span>
                <button
                  class="remove-image-btn"
                  (click)="removeImage(i)"
                  type="button"
                  title="Remove image"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center gap-3 p-3">
    <button class="cancel-btn" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button
      class="upload-btn"
      type="button"
      (click)="onSubmit()"
      [disabled]="isUploading"
    >
      <span *ngIf="!isUploading">Upload</span>
      <span *ngIf="isUploading" class="spinner"></span>
      <span *ngIf="isUploading">Uploading...</span>
    </button>
  </div>
</div>